/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Available HTTP methods for health and readiness checks.
 */
export enum HTTPMethod {
	GET = "GET",
	POST = "POST",
	PATCH = "PATCH",
	PUT = "PUT",
	OPTIONS = "OPTIONS",
	DELETE = "DELETE",
	HEAD = "HEAD",
}
